import { HttpErrorResponse } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { SharedConfig } from '../../shared/models/shared-config.model';
import { sharedConfig } from '../../shared/shared.config';
import { LoggerService } from '../logger/logger.service';
import { MessageHeplerService } from '../message-helper/message-helper.service';

@Injectable({
  providedIn: 'root'
})
export class HttpErrorHandlerService {

  constructor(
    private messageService: MessageHeplerService,
    private loggerService: LoggerService,
    @Inject(sharedConfig) private config: SharedConfig
  ) { }

  /**
   *
   *
   * Function to handle all the error received from Api response
   *
   *
   *
   * @param error Argument from api error-response
   * @returns An error Observable: emits only the error notification
   * using the given error argument.
   * @memberof HttpErrorHandlerService
   */
  handleHttpError(error: HttpErrorResponse): Observable<never> {
    switch (error.status) {
      case 400:
        this.handleException400(error);
        break;
      case 504:
        this.messageService.showErrorByKey('ERR_CODES', 'error_timeout');
        break;
      default:
        this.messageService.showErrorByKey('ERR_CODES', 'generic');
        break;
    }
    return throwError(error);
  }

  /**
   *
   *
   * Function to handle fuctional error
   *
   *
   *
   * @param error Argument from api error-response
   * @memberof HttpErrorHandlerService
   */
  handleException400(error: HttpErrorResponse): void {
    const errorData = (error.error) ? error.error : [];
    if (errorData.errors && errorData.errors.length > 0) {
      const firstError = errorData.errors[0];
      const skipErrorHandling = this.skipGeneralErrorHandling(firstError.errorCode);
      if (!skipErrorHandling) {
        if (firstError.errorCode) {
          this.messageService.showErrorByKey('ERR_CODES', firstError.errorCode);
        } else {
          this.messageService.showErrorByKey('ERR_CODES', 'generic');
        }
      }
    } else if (errorData && errorData.errorMessage && errorData.errorMessage.code) {
      const errCode = errorData.errorMessage.code.toString();
      const skipErrorHandling = this.skipGeneralErrorHandling(errCode);
      if (!skipErrorHandling) {
        this.messageService.showErrorByKey('ERR_CODES', errCode);
      }
      return errorData;
    } else {
      this.messageService.showErrorByKey('ERR_CODES', 'generic');
    }
  }

  /**
   *
   *
   * @name skipGeneralErrorHandling
   * @description Function to check for skip error handling error codes
   * @param errorCode Error code
   * @return  Boolean value
   * @memberof HttpErrorHandlerService
   */
  skipGeneralErrorHandling(errorCode: string): boolean {
    return (this.config.skipErrorCodes.indexOf(errorCode) > -1) ? true : false;
  }

  /**
   *
   *
   * Function to handle fuctional error received in 200
   *
   *
   *
   * @param error Argument from api error-response
   * @memberof HttpErrorHandlerService
   */
  handleExceptionWith200(errors): void {
    this.loggerService.logError(errors);
    if (errors && errors.length > 0) {
      const firstError = errors.find((err => err.errorCode !== null));
      if (firstError && firstError.errorCode) {
        this.messageService.showErrorByKey('ERR_CODES', firstError.errorCode);
      }
    }
  }
}
